import { render, staticRenderFns } from "./BSCard.vue?vue&type=template&id=5f270bc8&"
import script from "./BSCard.vue?vue&type=script&lang=js&"
export * from "./BSCard.vue?vue&type=script&lang=js&"
import style0 from "./BSCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports